export const OrderOverview = () => import('./OrderOverview').then(({ OrderOverview }) => {
    return {
      Component: OrderOverview
    };
  });